<template>
  <div id="produtos4">
    <div class="container-colchoes">
      <v-row>
        <v-col cols="12" md="4" sm="6" v-for="colchao in colchoes.slice(0, 4)" :key="colchao.id">
          <div class="card-colchao">
            <router-link :to="`produtos/${colchao.id}`" class="link">
              <div class="imagem">
                <div
                  class="background"
                  :style="{'background-image': 'url(' + require(`../assets/dados/imagens/${colchao.imagens[0]}`) + ')'}"
                ></div>
              </div>
              <button>{{ colchao.titulo}}</button>
            </router-link>
          </div>
        </v-col>
      </v-row>
      <!--
      <div class="btn-more-products">
          <router-link to="/produtos">Ver todos</router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
import produtos from "@/assets/dados/produtos.json";

export default {
  data() {
    return {
      colchoes: produtos.produtos
    };
  },
};
</script>

<style>

.btn-more-products {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-more-products a {
  padding: 10px 20px 10px 20px;
  background: #e17e4b;
  color: white !important;
  text-decoration: none;
}

#produtos4 {
  margin-top: 30px;
}

#produtos4 .background-preto {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

#produtos4 .titulo {
  height: 300px;
  text-align: center;
  background-position: center center;
}

#produtos4 .titulo p {
  color: white;
}

#produtos4 .titulo h1 {
  font-size: 54px;
  margin-bottom: 10px;
  color: white;
  font-weight: 900;
}

.container-colchoes {
  max-width: 1100px;
  margin: 0 auto;
}

.card-colchao {
  width: 100%;
  height: 300px;
  border-left: #e17e4b 3px solid;
  border-top: #e17e4b 3px solid;
  border-right: #e17e4b 3px solid;
  border-bottom: #e17e4b 0px solid;
}

.card-colchao img {
  transition: 0.3s;
  min-width: 100%;
  min-height: 100%;
}

.card-colchao .imagem {
  overflow: hidden;
  
  height: 250px;
}

.card-colchao .imagem .background {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: 0.3s;
}

.card-colchao .imagem:hover .background {
  transform: scale(1.2);
  transition: 0.3s;
}

.container-colchoes {
  margin-top: 40px;
  margin-bottom: 40px;
  padding: 20px;
}

#produtos4 .link {
  width: 100%;
  cursor: pointer;
}

#produtos4 .link button {
  border-right: 1px solid #e17e4b;
  border-left: 1px solid #e17e4b;
  border-bottom: 3px solid #e17e4b;
  border-top: 3px solid #e17e4b;
  color: #e17e4b;
  width: 100% !important;
  padding: 10px;
  transition: 0.4s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transform: translateY(-3px);
}

#produtos4 .link button:hover {
  background: #e17e4b;
  color: white;
  transition: 0.4s;
}
 
</style>